export default function Projects() {
    return(
        <div clasName="mil-wrapper">
          <div id="content">
            <section class="mil-banner mil-banner-sm">
                <img src="assets/images/background/background-1.png" class="mil-bg-img mil-scale" data-value-1=".4" data-value-2="1.4" alt="Tlo wykonanego domu." style={{ objectPosition: "top"}}/>
                <div class="container">
                    <div class="mil-background-grid mil-top-space"></div>
                    <div class="mil-banner-content mil-center">
                        <div class="mil-mb-90">
                            <h1 class="mil-light mil-upper mil-mb-30">KONTAKT</h1>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="container mil-p-120-60">
                    <div class="mil-background-grid mil-softened"></div>
                    <div class="row justify-content-between">
                        <div class="col-lg-6">

                            <div class="mil-mb-90">
                                <h2 class="mil-upper mil-up mil-mb-30">BUDUJEMY Z PASJĄ</h2>
                                <p class="mil-up mil-mb-40">HOŁ-BUD to firma zrodzona z pasji do budownictwa, przekazywanej z pokolenia na pokolenie. Nasze korzenie sięgają 1992 roku. Dziś, z ponad dekadą własnych doświadczeń na rynku i wiedzą szlifowaną w kraju i za granicą, oferujemy kompleksowe usługi budowlane.</p>
                                <p class="mil-up mil-mb-40">Specjalizujemy się w budowie "pod klucz", realizując wizje naszych klientów od projektu, przez budowę, aż po finalne wykończenie. Jesteśmy dumni z naszej historii i zaufania, jakim obdarzyli nas klienci.</p>
                            </div>

                        </div>
                        <div class="col-lg-4 mil-relative">

                            <div class="mil-contact-sidebar">

                                <div class="mil-sidebar-info">
                                  <h6 class="mil-upper mil-up mil-mb-30">Kontakt</h6>
                                  <p class="mil-dark mil-mb-30">Zapraszamy do kontaktu:<br />Pon - Piąt: 8:00 - 17:00</p>
                                  <p class="mil-dark mil-mb-5">Waryńskiego 33/2, 87-100 Toruń</p>
                                  <p class="mil-dark mil-mb-5">+48 534 727 286</p>
                                  <p class="mil-dark mil-mb-5">biuro@holtyn-bud.pl</p> 
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>

<section>
                <div class="container mil-p-120-60">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="row">
                        <div class="col-12">

                            <div class="mil-center mil-mb-90">
                                <span class="mil-suptitle mil-upper mil-up mil-mb-30">NASZA OFERTA</span>
                                <h2 class="mil-upper mil-up mil-mb-30">ZAJMIEMY SIĘ WSZYSTKIM<br />ZA CIEBIE!</h2>
                              
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">SŁUCHAMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Zaczynamy od rozmowy. Analizujemy Twoje potrzeby, pomysły i oczekiwania, aby w pełni zrozumieć wizję projektu.</p>
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">PLANUJEMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Tworzymy szczegółowy plan działania, harmonogram prac i profesjonalną wycenę. Rezerwujemy termin i załatwiamy formalności.</p>
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">BUDUJEMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Przechodzimy do realizacji. Nasz doświadczony zespół sprawnie i solidnie wykonuje wszystkie prace budowlane zgodnie z planem.</p>
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">WYKAŃCZAMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Dopracowujemy detale, wykonujemy prace wykończeniowe i przygotowujemy budynek do oficjalnego odbioru i przekazania kluczy.</p>
                            </div>

                        </div>

                    </div>
                </div>
            </section>


                      <div class="mil-illustration-slider-frame mil-up">
                <div class="swiper-container mil-illustration-slider">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">

                            <div class="mil-illustration mil-fw-item" data-swiper-parallax-x="50" data-swiper-parallax-scale="1.3">
                                <div class="mil-image-frame">
                                    <img src="assets/images/offer/residental/1.png" alt="Wykonany dom mieszkalny 1." />
                                </div>
                            </div>

                        </div>
                        <div class="swiper-slide">

                            <div class="mil-illustration mil-fw-item" data-swiper-parallax-x="50" data-swiper-parallax-scale="1.3">
                                <div class="mil-image-frame">
                                    <img src="assets/images/offer/residental2.png" alt="Wykonany dom mieszkalny 2." />
                                </div>
                            </div>

                        </div>
                        <div class="swiper-slide">

                            <div class="mil-illustration mil-fw-item" data-swiper-parallax-x="50" data-swiper-parallax-scale="1.3">
                                <div class="mil-image-frame">
                                    <img src="assets/images/offer/residental/3.png" alt="Wykonany dom mieszkalny 3." />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="mil-illustration-slider-nav mil-up">
                        <div class="mil-nav-buttons">
                            <div class="mil-slider-button mil-illustration-prev">Prev</div>
                            <div class="mil-slider-button mil-illustration-next">Next</div>
                        </div>
                    </div>
                </div>
            </div>

          </div>
        </div>
    )
}